import type { FaireProductEntity } from "../../entity_types/product";

export const p_qj2fj89sks: FaireProductEntity = {
  token: "p_qj2fj89sks",
  type: "product",
  name: "Kid's Nasal Spray, Medical Grade Manuka Honey",
  brandToken: "b_3u3fpywwwf",
  brandName: "ManukaGuard",
  imageUrl:
    "https://cdn.faire.com/fastly/a26aa877ed507af4f60ae86f262bd8c0553d1b20fb2f2c898d3e4097f299cd11.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48e623b33a2565d5cd5f0c5aae1f057350697d7f2784523d87de756d166ac14b.png",
    "https://cdn.faire.com/fastly/c8fce9d6a7e82b4a4f84df417671e6c0a7896c29e596b97b1a11fda19080084a.png",
    "https://cdn.faire.com/fastly/c9ad46e2eca49fd48cd6dc37034a45d5552aea95d39615039e30fb4812759fa8.png",
    "https://cdn.faire.com/fastly/41675c22b66c909c569ddbb8379946329c1aa9cbfcbeda66726219498a4bc9a2.png",
    "https://cdn.faire.com/fastly/2f6c3afab58aaec93f24cab6b28ce51f4e2a73b588c5639f1b1be3e5b48485c4.png",
    "https://cdn.faire.com/fastly/bd091e0cceba359f891bff403de6465218efe065e099e5ba38d78aa9ff84e8f1.jpeg",
    "https://cdn.faire.com/fastly/14ef508155d719a31cb66a246b15537f6fe5ffd0a614464e21ff7a19753b37fc.jpeg",
  ],
  priceDollars: 8.87,
  description:
    "Kid's Nasal Spray\n\nWhat does Kid’s Sinus Nasal Spray do? \n\nFast-acting and easy to use, the Kid’s Nasal Spray offers moms and dads a natural alternative to cleanse and moisturize their children’s nasal passages safely and effectively. \n\n\n\nThe cleansing and moisturizing action of Medical Grade Mānuka honey is documented in peer-reviewed, published research. ManukaGuard’s Nasal Sprays are formulated to deliver the optimal amount of honey in a fine mist.\n\n\n\nWhen Should I Use the Nasal Spray:\n\nUse Kid’s Nasal Spray when your child has a buildup or accumulation in the nasal passages and/or for cleansing and hydrating daily. Material may wash out of the nose, be prepared with tissues. \n\n\n\n\n\n\n\nIngredients: \n\nMedical-Grade Mānuka honey MGO 400, saline solution, vegetable glycerin, natural fruit and plant extracts, citric and ascorbic acids (Vitamin C), and purified water.\n\n\n",
  tags: [],
  msrpDollars: 14.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:11.835Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
